import React from "react"
import { Link } from "gatsby"

import { FaPhoneAlt, FaEnvelope } from "react-icons/fa"
import Subscribe from "sections/Subscribe"
import { Container, Row, Col } from "reusecore/Layout"
import Box from "reusecore/Box"
import Heading from "reusecore/Heading"
import Text from "reusecore/Text"

import {ImLab} from "react-icons/im"

import data from "assets/data/footer"
import FooterWrapper from "./footer.style"

const Footer = () => {
  return (
    <FooterWrapper>
      <Box className="footer-content-wrapper">
        <Subscribe />
        <Container>
          <Row>
            <Col className="lg-3 sm-6">
              <Box className="footer-widgets company-desc">
              <h3><ImLab/> PATLAB</h3>
                <Text>
                PATLAB es un empleador que ofrece igualdad de oportunidades para minorías, mujeres, movilidad alternativa, veteranos, identidad de género y orientación sexual.
                </Text>

                <Box className="contact-info">
                <a href="tel:+56 9 9703 2878"> {" "}
                    <FaPhoneAlt/> +56 9 9703 2878{" "} </a>
        
                </Box>
              </Box>
            </Col>
            <Col className="lg-3 sm-6">
              <Box className="footer-widgets">
                <Heading as="h2">Rubros de uso</Heading>
                <ul>
                  <li>Ecommerce</li>
                  <li>Lineas aereas</li>
                  <li>Compra y venta de automóviles</li>
                  <li>Inmoviliarias</li>
                  <li>Telefonía</li>
                  <li>Marketing</li>
                  <li>Contabilidad</li>
                  <li>Otros</li>
                </ul>
              </Box>
            </Col>
            <Col className="lg-3 sm-6">
              <Box className="footer-widgets">
                <Heading as="h2">Casos de uso</Heading>
          
                <ul>
                  <li>Estudio de precios</li>
                  <li>Cuadratura de cuentas bancarias vs contable</li>
                  <li>Protección de marcas</li>
                  <li>Testing automatizado</li>
                  <li>Investigaciones anti estafas</li>
                  <li>Análisis de campañas publicitarias</li>
                </ul>
                
              </Box>
            </Col>
            <Col className="lg-3 sm-6">
              <Box className="footer-widgets address">
                <Heading as="h2">Nuestra dirección</Heading>
                <Text className="pandemia">
                  Por pandemia nos hemos mudado a Bombero Patricio Canto Feliu 165 (Santiago Centro)
                </Text>
              </Box>
            </Col>
          </Row>
          <Row>
            <Col className="xs-12">
              <Box className="footer-social-links">
                {data.links.map((item, index) => (
                  <Link className="footer-social-links-each" to={item.url} key={index}>
                    {item.icon}
                  </Link>
                ))}
              </Box>

              <Box className="copyright-text">
                <Text>&copy; Patlab | Todos los derechos reservados 2021</Text>
                <Text as="span">
                  Diseñado por <Link to="#">Patlab</Link>
                </Text>
              </Box>
            </Col>
          </Row>
        </Container>
      </Box>
    </FooterWrapper>
  )
}

export default Footer;
